//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      list: [100, 101, 102, 103, 104, 105, 106, 107, 108, 109],
      page: 1,
      pageSize: 10
    }
  },
  methods: {
    refresh () {
      window.setTimeout(() => {
        let index = this.list[0]
        for (let i = 1; i <= this.pageSize; i++) {
          this.list.unshift(index - i)
        }
        this.$refs.myScroll.finishPullToRefresh()
      }, 2000)
    },
    infinite () {
      window.setTimeout(() => {
        let index = this.list.pop()
        this.list.push(index)
        for (let i = 1; i <= this.pageSize; i++) {
          this.list.push(index + i)
        }
        this.$refs.myScroll.finishInfinite()
      }, 2000)

    }
  }
}



// WEBPACK FOOTER //
// ./src/page/demo/scrollDemo.vue